import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { TKeepingSessionResponse } from './post-keeping-session';

export async function getKeepingSessions(
  workspaces?: string[]
): Promise<TKeepingSessionResponse[]> {
  return mediaManagerClient
    .get('/api/v1/time_keeping_sessions', {
      params: {
        ...(workspaces?.length && { workspace_id__in: workspaces.join(',') }),
      },
    })
    .then(({ data }) => data);
}

type QueryFnType = typeof getKeepingSessions;

type TUseGetKeepingSessionsParams = {
  workspaces?: string[];
  config?: QueryConfig<QueryFnType>;
};

export function useGetKeepingSessions({ workspaces, config }: TUseGetKeepingSessionsParams = {}) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['time-keeping-sessions', { workspaces }],
    queryFn: () => getKeepingSessions(workspaces),
  });
}
